<template>
    <b-form @submit.stop.prevent="patchCreateTranche($event)" :id="`tranche-form-${_uid}`">
      <b-card-group v-show="ready" deck>
        <b-card title="Informations générales">
          <b-form-group>
            <span :class="sliceStatus.variant">{{ sliceStatus.text }}</span>
          </b-form-group>

          <!-- Date AMEO -->
          <b-form-group label="Date AMEO*" label-cols="3">
            <date-picker v-model="tranche.ameoDate"
                  :config="config"
                  placeholder="JJ/MM/AAAA"
                  class="tranche-date-picker"
                  :class="(!ameoDateValid ? 'is-invalid datepicker-sm' : 'datepicker-sm')"
                  :disabled="!isAdmin() && !isAgent()">
            </date-picker>
          </b-form-group>

          <!-- Case Manager -->
          <b-form-group label="Chargé d'affaire*" label-cols="3">
            <b-form-select v-model="tranche.caseManager" :id="`tranche-case-manager-${_uid}`" :class="(!caseManagerValid ? 'is-invalid' : '')" size="sm" :disabled="!isAdmin() && !isAgent()">
                <option :value="null">-- Merci de choisir un chargé d'affaire --</option>
                <option v-for="(caseManager, index) in caseManagers" :value="caseManager" :key="index">
                    {{ formatCaseManagerName(caseManager) }}
                </option>
            </b-form-select>
          </b-form-group>

          <!-- Date completeness -->
          <b-form-group label="Date de réception" label-cols="3">
            <date-picker v-model="tranche.receptionDate"
                  :config="config"
                  placeholder="JJ/MM/AAAA"
                  class="tranche-date-picker datepicker-sm"
                  :disabled="!isAdmin() && !isAgent()">
            </date-picker>
          </b-form-group>

          <!-- Agency -->
          <b-form-group label="Agence*" label-cols="3">
            <b-form-select v-model="tranche.agency.id" :id="`tranche-case-manager-${_uid}`" :class="(!agencyValid ? 'is-invalid' : '')" size="sm" :disabled="!isAdmin() && !isAgent()">
                <option :value="null">-- Merci de choisir une agence --</option>
                <option v-for="(agency, index) in agencies" :value="agency.id" :key="index">
                    {{ agency.type }} - {{ agency.name }}
                </option>
            </b-form-select>
          </b-form-group>

          <!-- PalRro / Classe A -->
          <div id="checkboxGroup">
            <b-form-checkbox v-model="tranche.palRro" :disabled="!isAdmin() && !isAgent()">PAL RRO</b-form-checkbox>
            <b-form-checkbox v-model="tranche.classA" :disabled="!isAdmin() && !isAgent()">Classe A</b-form-checkbox>
          </div>

          <!-- Date completeness -->
          <b-form-group label="Date de complétude du dossier" label-cols="5">
            <date-picker v-model="tranche.completeDate"
                  :config="config"
                  placeholder="JJ/MM/AAAA"
                  class="tranche-date-picker datepicker-sm"
                  :disabled="!isAdmin() && !isAgent()">
            </date-picker>
          </b-form-group>

          <!-- Delay Elapsed -->
          <b-form-group id="spentTime">
            <label>Délais Écoulé <span>{{ progressBar.days }} jour(s).</span></label>
            <b-progress :max="parseInt(30)" :value="parseInt(progressBar.days)" :variant="progressBar.variant"></b-progress>
          </b-form-group>

          <b-form-group>
            <div class="tranche-buttons">
            <DeleteConfirmButton
                    v-if="!isNew() && (isAdmin() || isAgent())"
                    message="Supprimer le dossier"
                    title="Supprimer le dossier"
                    @confirmed="archiveTranche()"/>

            <b-button class="save-btn"
                      type="submit"
                      variant="primary"
                      :form="`tranche-form-${_uid}`"
                      v-if="isAdmin() || isAgent()"><svg id="savePicto" viewBox="0 0 24.42 20" style="enable-background:new 0 0 24.42 20;" xml:space="preserve"><path class="st3" d="M24.15,6.71c-0.31-0.41-0.85-0.67-1.41-0.67h-1.31V3.82c0-0.9-0.71-1.63-1.58-1.63h-8.99l-1.3-1.85 C9.42,0.13,9.17,0,8.91,0H1.72C0.81,0,0.07,0.74,0.07,1.65v16.33c-0.13,0.44-0.08,0.91,0.17,1.3C0.53,19.73,1.04,20,1.61,20h16.95 c1.14,0,1.44-0.91,1.59-1.35l4.2-10.73C24.48,7.5,24.41,7.06,24.15,6.71z M8.48,1.62l1.3,1.85c0.15,0.22,0.4,0.34,0.66,0.34l9.36,0 v2.22H5.8c-1.13,0-1.47,1.01-1.59,1.35L1.7,13.78L1.72,1.62H8.48z M18.62,18.09c-0.05,0.14-0.08,0.23-0.11,0.28l-16.88,0L5.73,7.94 C5.78,7.79,5.82,7.7,5.85,7.66h16.87L18.62,18.09z"/><path class="st3" d="M11.64,17.19c0.07,0.08,0.16,0.13,0.26,0.18c0.1,0.04,0.2,0.06,0.31,0.06c0.11,0,0.21-0.02,0.31-0.06 c0.1-0.04,0.19-0.1,0.26-0.18l2.29-2.29c0.32-0.32,0.32-0.83,0-1.15c-0.32-0.32-0.83-0.32-1.15,0l-0.91,0.91V9.42 c0-0.45-0.36-0.81-0.81-0.81c-0.45,0-0.81,0.36-0.81,0.81v5.23l-0.94-0.94c-0.32-0.32-0.83-0.32-1.15,0 c-0.32,0.32-0.32,0.83,0,1.15L11.64,17.19z"/></svg>Sauvegarder</b-button>
            </div>
          </b-form-group>
        </b-card>

        <b-card title="Aléas" v-if="!isNew()">
          <GapHistoriesTable :gap-histories="tranche.gapHistories"/>
          <div id="addHistoryBtn">
            <ShowGapHistoryTypeButton v-if="isAdmin() || isAgent()" :tranche="tranche" title="Ajouter un aléa"/>
          </div>
        </b-card>
      </b-card-group>
    </b-form>
</template>

<script>
import { mapGetters } from 'vuex';
import Clone from 'clone';
import TrancheService from '../../services/TrancheService';
import CaseManagerService from '../../services/CaseManagerService';

const $ = require('jquery');

const moment = require('moment');

export default {
  name: 'TrancheType',
  props: {
    title: {
      type: String,
      default: 'Nouveau dossier',
    },
    tranche: {
      type: Object,
      default() {
        return {
          ameoDate: null,
          caseManager: null,
          status: 'En stock',
          gapHistories: [],
          palRro: null,
          completeDate: null,
          receptionDate: null,
          classA: null,
        };
      },
    },
  },
  data() {
    return {
      agencies: [],
      ready: false,
      sliceClone: null,
      ameoDateValid: true,
      caseManagerValid: true,
      agencyValid: true,
      progressBar: {
        days: 0,
        variant: null,
      },
      sliceStatus: {
        variant: null,
        text: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      userSession: 'getUserSession',
    }),
    config() {
      const size = this.getViewPortSize();
      return {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        showClear: true,
        showClose: true,
        locale: moment.locale('fr'),
        focusOnShow: false,
        ignoreReadonly: true,
        allowInputToggle: true,
        widgetPositioning: {
          horizontal: ['sm', 'xs'].indexOf(size) !== -1 ? 'right' : 'left',
        },
      };
    },
    caseManagers() {
      if (this.getCaseManagerList() === null || typeof this.getCaseManagerList() === 'undefined') {
        return [];
      }
      let list = Clone(this.getCaseManagerList());
      list = list.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });
      return list;
    },
  },
  methods: {
    ...mapGetters([
      'getTrancheStatusEnumeration',
      'getCaseManagerList',
      'getEnedisCaseOnGoing',
      'getViewPortSize',
      'getAgencies',
      'isAdmin',
      'isAgent',
    ]),
    formatCaseManagerName(caseManager) {
      return CaseManagerService.formatName(caseManager);
    },
    patchCreateTranche(event) {
      if(!this.isAdmin() && !this.isAgent()) {
        return;
      }

      // Format tranche data to send
      const trancheForm = Clone(this.tranche);

      // Checking if required fields are populated, if not throw an error
      if (trancheForm.ameoDate == null) {
        this.ameoDateValid = false;
      } else {
        this.ameoDateValid = true;
      }

      if (trancheForm.caseManager == null) {
        this.caseManagerValid = false;
      } else {
        this.caseManagerValid = true;
      }

      if (trancheForm.agency.id == null) {
        this.agencyValid = false;
      } else {
        this.agencyValid = true;
      }

      if (this.ameoDateValid == false || this.caseManagerValid == false || this.agencyValid == false) {
        // Show error toast
        const toast = {
          show: true,
          message: 'Merci de remplir tous les champs obligatoires.',
          variant: 'danger',
          duration: 3000,
        };
        this.$store.commit('setGlobalToaster', toast);
        return;
      }

      // No needs to send collection, there are specials endpoints for that
      delete trancheForm.gapHistories;

      // Id are auto increment, don't patch it
      if (typeof trancheForm.id !== 'undefined') {
        delete trancheForm.id;
      }
      // The back end will transform id in Agent entity
      trancheForm.caseManager = trancheForm.caseManager === null
        ? null : this.tranche.caseManager.id;
      // Prepare data
      const data = {
        form: trancheForm,
        id: this.isNew() ? this.getEnedisCaseOnGoing().id : this.tranche.id,
      };

      if (this.isNew()) {
          // Creation
          let formData = new FormData();
          const formatAmeo = trancheForm.ameoDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';

          formData.append('ameoDate', moment(trancheForm.ameoDate, formatAmeo).format('YYYY-MM-DD HH:mm'));
          formData.append('caseManager', trancheForm.caseManager === null ? null : this.tranche.caseManager.id);
          formData.append('agency', trancheForm.agency.id);
          formData.append('palRro', trancheForm.palRro);
          formData.append('classA', trancheForm.classA);

          if (trancheForm.completeDate != null) {
            const formatComplete = trancheForm.completeDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.append('completeDate', moment(trancheForm.completeDate, formatComplete).format('YYYY-MM-DD HH:mm'));
          }

          if (trancheForm.receptionDate != null) {
            const formatComplete = trancheForm.receptionDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.append('receptionDate', moment(trancheForm.receptionDate, formatComplete).format('YYYY-MM-DD HH:mm'));
          }

          axios.post(`tranches/${this.getEnedisCaseOnGoing().id}`, formData)
            .then((response) => {
              // Show success toast
              const toast = {
                show: true,
                message: 'Tranche créée avec succès !',
                variant: 'success',
                duration: 3000,
              };
              this.$store.commit('setEnedisCaseOnGoing', typeof response.data !== 'undefined' ? response.data : response);
              this.$emit(typeof response.data !== 'undefined' ? 'created' : 'updated');
              this.$store.commit('setGlobalToaster', toast);

              EnumerationService.setEnums(this.$store, {
                tranche: response.data._embedded.tranche_status_enumeration,
                trancheUpdate: response.data._embedded.tranche_update_status_enumeration,
              });
              store.commit('setTrancheStatusEnumeration', EnumerationService.getEnum(response.data._embedded.tranche_status_enumeration));
            })
            .catch((error) => {
              console.error(error.message);
            });
        } else {
          // Patch
          const formatAmeo = trancheForm.ameoDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';

          let formData = {
            ameoDate: moment(trancheForm.ameoDate, formatAmeo).format('YYYY-MM-DD HH:mm'),
            caseManager: trancheForm.caseManager === null ? null : this.tranche.caseManager.id,
            agency: trancheForm.agency.id,
            palRro: trancheForm.palRro,
            classA: trancheForm.classA,
          };

          if (trancheForm.completeDate != null) {
            const formatComplete = trancheForm.completeDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.completeDate = moment(trancheForm.completeDate, formatComplete).format('YYYY-MM-DD HH:mm');
          } else {
            formData.completeDate = null;
          }

          if (trancheForm.receptionDate != null) {
            const formatComplete = trancheForm.receptionDate.length > 10 ? 'YYYY-MM-DD HH:mm' : 'DD/MM/YYYY';
            formData.receptionDate = moment(trancheForm.receptionDate, formatComplete).format('YYYY-MM-DD HH:mm');
          } else {
            formData.receptionDate = null;
          }

          axios.patch(`tranches/${this.tranche.id}`, formData)
              .then((response) => {
                // Show success toast
                const toast = {
                  show: true,
                  message: 'Tranche modifiée avec succès !',
                  variant: 'success',
                  duration: 3000,
                };
                this.$store.commit('setEnedisCaseOnGoing', typeof response.data !== 'undefined' ? response.data : response);
                // Emit event when tranche is created or updated
                this.$emit(typeof response.data !== 'undefined' ? 'created' : 'updated');
                this.$store.commit('setGlobalToaster', toast);

                // Updating slice status and progress bar
                response.data.tranches.forEach((slice) => {
                  if (slice.id == this.tranche.id) {
                    this.sliceStatus = this.getSliceStatus(slice);
                    this.progressBar = TrancheService.getProgressData(slice);
                  }
                });
              })
              .catch((error) => {
                console.error(error.message);
              });
        }
    },
    archiveTranche() {
      if (this.isNew()) {
        return;
      }

      let formData = {
        isArchived: true,
      };

      axios.patch(`tranches/${this.tranche.id}`, formData)
            .then((response) => {
              // Show success toast
              const toast = {
                show: true,
                message: 'Tranche supprimée avec succès !',
                variant: 'success',
                duration: 3000,
              };
              this.$store.commit('setEnedisCaseOnGoing', response.data);
              // Emit event when tranche is created or updated
              this.$emit('archived');
              this.$store.commit('setGlobalToaster', toast);
            })
            .catch((error) => {
              console.error(error.message);
            });
    },
    isNew() {
      return typeof this.tranche.id === 'undefined';
    },
    getProgressColor(value) {
      let val = parseInt(value);
      if (val < 15) {
        return 'success';
      } else if (val >= 15 && val < 30) {
        return 'warning';
      } else {
        return 'danger';
      }
    },
    getSliceStatus(slice) {
      if (slice == null || slice.completeDate == null) {
        return {
          variant: "ongoing",
          text: "En cours",
        };
      } else {
        return {
          variant: "filled",
          text: "Complet",
        };
      }
    },
    setProgressBar(slice) {
      this.progressBar = TrancheService.getProgressBar(slice);
    },
  },
  beforeMount() {
    if (typeof this.getCaseManagerList() === 'undefined' || this.getCaseManagerList() === null) {
      this.$store.dispatch('getCaseManagers').then(() => {}, () => {});
    }
  },
  mounted() {
    // this.sliceClone = Clone(this.tranche);
    this.sliceStatus = this.getSliceStatus(this.tranche);
    if (this.isNew()) {
      this.tranche.caseManager = this.userSession;
    } else if (this.tranche.ameoDate !== null && typeof this.tranche.ameoDate !== 'undefined') {
      this.tranche.ameoDate = moment(this.tranche.ameoDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    }

    if (this.tranche.completeDate !== null && typeof this.tranche.completeDate !== 'undefined') {
      this.tranche.completeDate = moment(this.tranche.completeDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    }

    if (this.tranche.receptionDate !== null && typeof this.tranche.receptionDate !== 'undefined') {
      this.tranche.receptionDate = moment(this.tranche.receptionDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY');
    }

    $(() => {
      // Set input date time picker to readonly because of the keyboard mobile event
      $('.ameo-date-group-input input').attr('readonly', 'readonly');
    });

    this.ready = false;

    // Checking if agencies are in the Store. If not, fetch and store them
    if (this.getAgencies().length == 0) {
      this.$store.dispatch('fetchAgencies').then(() => { this.agencies = this.getAgencies(); });
    } else {
      this.agencies = this.getAgencies();
    }

    // Setting progress bar
    this.progressBar = TrancheService.getProgressData(this.tranche);

    this.ready = true;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#spentTime {
  span {
    font-weight: normal;
    margin-left: 20px;
  }
}

.datepicker-sm {
  height: calc(1.5em + .5rem + 2px);
padding-top: .25rem;
padding-bottom: .25rem;
padding-left: .75rem;
font-size: .875rem;
}

.save-btn {
  background-color: #005EB8;
  border-color: #005EB8;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
  // padding: 5px 25px;
  display: flex;
  flex-direction: row;
  align-items: center;

  #savePicto {
    fill: white;
    width: 25px;
    margin-right: 10px
  }

  &:hover,
  &:focus,
  &:active {
    background-color: white;
    color: #005EB8;

    #savePicto {
      fill: #005EB8 !important;
    }
  }
}

.tranche-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#addHistoryBtn {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/form/TrancheType.vue